import {Col, Modal, Row, Form, InputNumber, Button} from 'antd'
import {
  SBack,
  SSegmentedTabs,
  STableActions,
  SActionBtn, SFuncModal, SDrawerOrModal
} from 'shj-components'
import {useEffect} from "react";
import {isEmpty} from "lodash-es";

const StoreSetModal = props => {
  const {open, onClose, onChangeTableData, record} = props
  const [form] = Form.useForm();

  useEffect(() => {
    if (!isEmpty(record)) form.setFieldsValue(record)
  }, [record]);

  const onFinish = () => {
    form.validateFields().then((values) => {
      onChangeTableData?.(values)
      onClose()
    });
  }

  return (
      <SDrawerOrModal
          mode={'modal'}
          open={open}
          onCancel={onClose}
          width={500}
          title="库存设置"
          onOk={onFinish}
      >
        <Form
            style={{padding: "10px 0"}}
            form={form}
            layout={'vertical'}
        >
          <Form.Item
              name="stockNum"
              label="库存量"
              rules={[
                {
                  required: true,
                  message: '请填写库存量',
                },
              ]}
          >
            <InputNumber min={0} precision={0} style={{width: '100%'}} placeholder={'请填写库存量'}/>
          </Form.Item>
        </Form>
      </SDrawerOrModal>
  )
}

export default StoreSetModal
